import React from 'react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 bg-green-950/90 backdrop-blur-md text-white z-50 py-3 px-4 shadow-md border-b border-green-700/30" data-id="element-254">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-sm sm:text-base font-bold text-center" data-id="element-255">
        <span data-id="element-256">🔥</span>
        <span data-id="element-257">OFERTA DE LANZAMIENTO</span>
        <span data-id="element-258">🔥</span>
      </div>
    </div>;
}